<template>
  <a-select
      ref="select"
      :value="selectVal"
      style="width: 100%"
      @change="handleChange"
      allowClear
      showSearch
      optionFilterProp="name"
      :filterSort="filterSort"
      :disabled="disabled"
  >
    <a-select-option v-for="item in list" :value="item[optionValue]" :key="item[optionValue]" :name="item[optionText]">
      {{
        item[optionText]
      }}
    </a-select-option>
  </a-select>
</template>

<script>
import util from "@/util/util";

export default {
  name: "selectIdAndName",
  props: {
    list: Array,
    optionValue: String,
    optionText: String,
    value: String,
    disabled : Boolean,
    sortBy : String
  },
  emits: ['update:value'],
  data() {
    return {
      selectVal: ""
    }
  },
  mounted() {
    this.selectVal = this.value
  },
  methods: {
    handleChange(value) {
      this.selectVal = value
      this.$emit("update:value", value)
    },
    filterSort(optionA, optionB){
      if (util.isNull(this.sortBy)){
        return util.sorter(optionA.name, optionB.name)
      }else {
        return util.sorter(optionA[this.sortBy], optionB[this.sortBy])
      }
    }
  },
  watch:{
    value(){
      this.selectVal = this.value;
    }
  }
}
</script>

<style scoped>

</style>